import { observer } from 'mobx-react-lite';
import { Box } from '@cad-arc';
import { CommandLinePanel } from '../command-line/command-line-panel';
import { ContactListPanel } from '../contact-list/contact-list-panel';
import { DexFormPanel } from '../data-exchange/forms/dex-form-panel';
import { DexFormsPanel } from '../data-exchange/forms/dex-forms-panel';
import { DexResultsPanel } from '../data-exchange/results/dex-results-panel';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { EventPanel } from '../event-panel/event-panel';
import { MessagingPanel } from '../messaging/components/messaging-panel';
import { QueueCreationPanel } from '../queues/components/queue-creation-panel';
import { QueuePanel } from '../queues/components/queue-panel';
import { UnitHistory as UnitHistoryPanel } from '../unit-history';
import { usePanelArea } from './panel-area';
import { enabledFeatureForViewByPanelType } from './panel-configuration';
import { useWorkspaceStore } from './use-workspace-store';
import { BoloPanel } from '../bolos/bolo-panel/panel-components/bolo-panel';
import { AttachmentsPanel } from '../attachments/attachments-panel';

export const WorkspacePanels = observer(function PanelCollectionRenderer() {
    const workspacePanelsStore = useWorkspaceStore();
    const enabledFeatures = useEnabledFeatures();
    const resizeObserverRef = usePanelArea().current.resizeObserverRef;
    return (
        // 1px padding here accounts for panels having a 1px boxshadow outside the panel size.  when the panel is
        // at the edge of the panel container, the padding here allows the boxshadow to be visible without getting cut off.
        <Box position="relative" w="100%" h="100%" overflow="hidden" padding="px">
            {/* panel container */}
            <Box w="100%" h="100%" position="inherit" ref={resizeObserverRef}>
                {workspacePanelsStore.activePanels.map((panel) => {
                    const featureForPanelType =
                        enabledFeatureForViewByPanelType[panel.workspacePanelType];
                    if (featureForPanelType && !enabledFeatures[featureForPanelType]) {
                        return null;
                    }
                    switch (panel.workspacePanelType) {
                        case 'EVENT':
                            return <EventPanel key={panel.initialId} panel={panel} />;
                        case 'SCHEDULED_EVENT':
                            return <EventPanel key={panel.initialId} panel={panel} />;
                        case 'COMMAND_LINE':
                            return <CommandLinePanel key={panel.initialId} panel={panel} />;
                        case 'CONTACT_LIST':
                            return <ContactListPanel key={panel.initialId} panel={panel} />;
                        case 'MESSAGING':
                            return <MessagingPanel key={panel.initialId} panel={panel} />;
                        case 'DATA_EXCHANGE_FORM':
                            return <DexFormPanel key={panel.initialId} panel={panel} />;
                        case 'DATA_EXCHANGE_FORMS':
                            return <DexFormsPanel key={panel.initialId} panel={panel} />;
                        case 'DATA_EXCHANGE_RESULTS':
                            return <DexResultsPanel key={panel.initialId} panel={panel} />;
                        case 'QUEUE':
                            return <QueuePanel key={panel.initialId} panel={panel} />;
                        case 'QUEUE_FORM':
                            return <QueueCreationPanel key={panel.initialId} panel={panel} />;
                        case 'UNIT_HISTORY':
                            return <UnitHistoryPanel key={panel.initialId} panel={panel} />;
                        case 'BOLO':
                            return <BoloPanel key={panel.initialId} panel={panel} />;
                        case 'MEDIA_ATTACHMENTS':
                            return <AttachmentsPanel key={panel.initialId} panel={panel} />;
                        default:
                            return null;
                    }
                })}
            </Box>
        </Box>
    );
});
